import { Injectable } from "@snap/ts-inject";
import { RemoteApiSpecsDefinition } from "../generated-proto/pb_schema/camera_kit/v3/remote_api_spec";
import type { TsProtoServiceClient } from "./createTsProtoClient";
import { createTsProtoClient } from "./createTsProtoClient";
import type { GrpcHandler } from "./grpcHandler";
import { grpcHandlerFactory } from "./grpcHandler";

export type RemoteApiSpecsClient = TsProtoServiceClient<typeof RemoteApiSpecsDefinition>;

export const remoteApiSpecsClientFactory = Injectable(
    "remoteApiSpecsClient",
    [grpcHandlerFactory.token] as const,
    (grpcHandler: GrpcHandler): RemoteApiSpecsClient => createTsProtoClient(RemoteApiSpecsDefinition, grpcHandler)
);
